export const experienceData = [
    {
        id: 6,
        company: 'Lookin Technologies PVT LTD',
        jobtitle: 'MERN Stack(React & React Native) Developer',
        startYear: 'Feb 2025 ',
        endYear: ' Present'
    },
    {
        id: 5,
        company: 'Eazisols',
        jobtitle: 'MERN Stack(React & React Native) Developer',
        startYear: 'Sept 2023 ',
        endYear: 'Feb 2025'
    },
    {
        id: 4,
        company: 'Percise Tech',
        jobtitle: 'Junier React JS Developer',
        startYear: 'May 2023 ',
        endYear: ' Sept 2023'
    },
    // {
    //     id: 3,
    //     company: 'Fiverr(freelance)',
    //     jobtitle: 'Front-End Developer',
    //     startYear: 'August 2022 ',
    //     endYear: ' March 2023'
    // },
    {
        id: 2,
        company: 'Algolix',
        jobtitle: 'Internee(Front-End)',
        startYear: 'May 2022 ',
        endYear: ' July 2022'
    },

]